export const BRUTO = "Bruto";
export const NETTO = "Netto";
export const CANCELLED = "Cancelled";
export const NOSALE = "NoSale";
export const MANUAL = "Manual";
